module.exports = __webpack_public_path__ + "static/media/pag-LandingPage-Box-ExcelenteMedalha-h.c1fb684e.c1fb684e.png";